import { render } from "./ExpandableListItemDetail.vue?vue&type=template&id=60433c74"
import script from "./ExpandableListItemDetail.vue?vue&type=script&lang=js"
export * from "./ExpandableListItemDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ExpandableListItemDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60433c74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60433c74', __exports__)) {
    console.log('reload')
    api.reload('60433c74', __exports__)
  }
  
  module.hot.accept("./ExpandableListItemDetail.vue?vue&type=template&id=60433c74", () => {
    console.log('re-render')
    api.rerender('60433c74', render)
  })

}


export default __exports__